import React from 'react';
import { useClientAuthStore } from '@/store/useClientAuthStore';
import { Link } from 'react-router-dom';

const HomePage = () => {
  const { user } = useClientAuthStore();

  return (
    <div>
      {/* Welcome Section */}
      <div className="bg-white rounded-lg shadow p-6 mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          ¡Bienvenido/a, {user?.fullName}!
        </h1>
        <p className="text-gray-600">
          Gestiona tus servicios automotrices desde tu portal personal
        </p>
      </div>

      {/* Acción Principal - Reserva Rápida */}
      <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg shadow-lg p-8 mb-8 text-white text-center">
        <h2 className="text-2xl font-bold mb-2">¿Necesitas una cita?</h2>
        <p className="text-blue-100 mb-6">Reserva tu servicio en solo 3 pasos simples</p>
        <Link 
          to="/quick-book" 
          className="inline-flex items-center px-8 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          Reservar Cita Ahora
        </Link>
      </div>

      {/* Quick Actions */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Servicios</h3>
          <p className="text-gray-600 text-sm mb-4">
            Explora nuestros servicios automotrices
          </p>
          <Link 
            to="/services" 
            className="text-blue-600 hover:text-blue-700 font-medium text-sm"
          >
            Ver servicios →
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Mis Citas</h3>
          <p className="text-gray-600 text-sm mb-4">
            Revisa tus citas programadas
          </p>
          <Link 
            to="/appointments" 
            className="text-green-600 hover:text-green-700 font-medium text-sm"
          >
            Ver citas →
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Mi Perfil</h3>
          <p className="text-gray-600 text-sm mb-4">
            Actualiza tu información personal
          </p>
          <Link 
            to="/profile" 
            className="text-purple-600 hover:text-purple-700 font-medium text-sm"
          >
            Ver perfil →
          </Link>
        </div>
      </div>

      {/* Taller Info */}
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center space-x-3 mb-4">
          <img 
            src="/images/centro-automotriz-hlfrd-icon-4.ico" 
            alt="Centro Automotriz HLFRD"
            className="w-12 h-12 object-contain"
          />
          <h2 className="text-xl font-bold" style={{ color: '#2C3E50' }}>Centro Automotriz HLFRD</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h3 className="font-semibold text-gray-900 mb-2">Nuestros Servicios</h3>
            <ul className="text-gray-600 text-sm space-y-1">
              <li>✓ Mantenimiento preventivo</li>
              <li>✓ Reparaciones de motor</li>
              <li>✓ Sistema de frenos</li>
              <li>✓ Diagnóstico computarizado</li>
              <li>✓ Afinación completa</li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-2">Horarios</h3>
            <div className="text-gray-600 text-sm space-y-1">
              <div>Lun - Sáb: 8:00 AM - 7:00 PM</div>
              <div>Domingos: Cerrado</div>
              <div className="pt-2">
                <span className="font-medium">📍</span>
                <a
                  href="https://www.google.com/maps/place/Centro+Automotriz+HLFRD/@18.4924308,-69.935612,17z/data=!3m1!4b1!4m6!3m5!1s0x8eaf890062737321:0x6895b1dc2fb10ce5!8m2!3d18.4924257!4d-69.9330371!16s%2Fg%2F11x1rq80fn?entry=ttu&g_ep=EgoyMDI1MDkxMC4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-700 hover:underline"
                >
                  Av. Lope de Vega, La Agustina, C/ U 9-B en Santo Domingo, República Dominicana
                </a>
              </div>
              <div>
                <span className="font-medium">📞</span> +18299833174
              </div>
              <div className="pt-2">
                <span className="font-medium">🌐</span> Síguenos en:
                <div className="flex gap-3 mt-2">
                  <a
                    href="https://web.facebook.com/hlf.rd.2025"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-blue-600 hover:text-blue-700 transition-colors"
                    title="Facebook"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                    Facebook
                  </a>
                  <a
                    href="https://www.youtube.com/@HLFRD"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-red-600 hover:text-red-700 transition-colors"
                    title="YouTube"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                    </svg>
                    YouTube
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;